import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { useLplModel } from "../lplModel";
import { ColumnsType } from "antd/lib/table";
import { ILplDetail } from "../lplService";


export const NoteDialog = () => {
    const { noteDialog: { visible, row }, setNoteDialog } = useLplModel(({ noteDialog }) => [noteDialog])
    //列表数据源
    const [dataSource, setDataSource] = useState<any[]>([]);

    useEffect(() => {
        visible && loadData()
    }, [visible])

    const loadData = async () => {
        let { consignmentNote, carryNote, releaseNote, shipmentNote, ladingNote } = row ?? {} as ILplDetail;
        setDataSource([
            {
                date: "订舱日期",
                note: consignmentNote ?? ""
            },
            {
                date: "装柜日期",
                note: carryNote ?? ""
            },
            {
                date: "报关日期",
                note: releaseNote ?? ""
            },
            {
                date: "海关放行日期",
                note: releaseNote ?? ""
            },
            {
                date: "装船日期",
                note: shipmentNote ?? ""
            },
            {
                date: "提单日期",
                note: ladingNote ?? ""
            }
        ])
    }

    const onCancel = () => {
        setNoteDialog({ visible: false });
    };


    const column: ColumnsType<any> = [
        {
            title: '日期',
            dataIndex: 'date',
            width: 120,
            align: "center"
        }, {
            title: '备注内容',
            dataIndex: 'note',
            align: "center"
        }
    ];


    return <YHModal
        visible={visible}
        onOk={onCancel}
        onCancel={onCancel}
        title="备注详情"
        width={360}
        bodyHeight={400}
        showFooter={true}
    >
        <YhBox title=" " style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                bordered
                rowKey={record => record.date}
                columns={column}
                dataSource={dataSource}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    </YHModal>
}